import {
  LegalClientLegalAddressEntity,
  RegistrationAddressEntity,
} from 'api/types/entity';
import { FileUpload } from 'hooks';
import { Maybe } from 'types/maybe';

import { CompanyAddressFormType } from '../../forms/companyAddressForm';

interface Props {
  legalAddress?: Maybe<LegalClientLegalAddressEntity>;
  actualAddress?: Maybe<RegistrationAddressEntity>;
}

export const getBaseInitialData = (
  legalAddress: LegalClientLegalAddressEntity,
  actualAddress?: Maybe<Partial<RegistrationAddressEntity>>
) => {
  const values: CompanyAddressFormType = {
    countryLegal: legalAddress.country,
    localityLegal: legalAddress.locality,
    regionLegal: legalAddress.region,
    areaLegal: legalAddress.district || undefined,
    streetLegal: legalAddress.street,
    houseNumberLegal: legalAddress.house,
    housingLegal: legalAddress.building || undefined,
    apartmentLegal: legalAddress.apartment || undefined,
    postcodeLegal: legalAddress.postalCode,
    confirmationFileIds: legalAddress?.confirmationFiles?.map((v) => v.id),
    actualAddressIsSame: false,
  };

  values.countryActual = actualAddress?.country;
  values.localityActual = actualAddress?.locality;
  values.regionActual = actualAddress?.region;
  values.areaActual = actualAddress?.district || undefined;
  values.streetActual = actualAddress?.street;
  values.houseNumberActual = actualAddress?.house;
  values.housingActual = actualAddress?.building || undefined;
  values.apartmentActual = actualAddress?.apartment || undefined;
  values.postcodeActual = actualAddress?.postalCode;

  const files: FileUpload[] | undefined = legalAddress?.confirmationFiles?.map(
    (v) =>
      new FileUpload({ name: v.name, size: v.size }, undefined, false, v.id)
  );
  return { values, files };
};

export const getInitialData = (client: Props) => {
  if (!client.legalAddress) {
    return undefined;
  }

  const values = getBaseInitialData(client.legalAddress, client.actualAddress);

  return values;
};
